"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LegacyInCallCustomerDetails = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const ui_react_1 = require("@streem/ui-react");
const room_session_1 = require("../../../context/room_session");
const rxjs_1 = require("../../../hooks/rxjs");
const LegacyInCallCustomerDetails = () => {
    var _a, _b;
    const roomSession = (0, room_session_1.useRoomSession)();
    const [room] = (0, rxjs_1.useObservable)(roomSession === null || roomSession === void 0 ? void 0 : roomSession.room.room);
    if (!((_a = room === null || room === void 0 ? void 0 : room.details) === null || _a === void 0 ? void 0 : _a.length))
        return null;
    return ((0, jsx_runtime_1.jsx)(DetailsSection, { children: (_b = room === null || room === void 0 ? void 0 : room.details) === null || _b === void 0 ? void 0 : _b.map(section => {
            return ((0, jsx_runtime_1.jsxs)(SectionContainer, { children: [(0, jsx_runtime_1.jsx)(ui_react_1.AppText, Object.assign({ as: "h6", headingFontFamily: true, semibold: true, "data-testId": `${section.label}-label` }, { children: section.label })), (0, jsx_runtime_1.jsx)(ui_react_1.AppText, Object.assign({ "data-testId": `${section.label}-value` }, { children: section.value }))] }, section.label));
        }) }));
};
exports.LegacyInCallCustomerDetails = LegacyInCallCustomerDetails;
const DetailsSection = (0, ui_react_1.styled)(ui_react_1.Box)(({ theme }) => ({
    marginTop: '20px',
    padding: '16px',
    border: `solid 1px ${theme.colors.grey10}`,
    borderRadius: '10px',
}));
const SectionContainer = (0, ui_react_1.styled)(ui_react_1.Box)({
    ':not(:last-of-type)': {
        marginBottom: '24px',
    },
});
//# sourceMappingURL=legacy_in_call_customer_details.js.map